import "@szhsin/react-menu/dist/index.css";
import { observer } from "mobx-react";
import React from "react";
import { withWSErrorContainer } from "../../../error/withWSErrorContainer";
import { useReactMenuProps } from "../../../generic-components/common/useReactMenuProps";
import { useWhoAmI } from "../../../user/useWhoAmI";
import { useDevice } from "../../../utils/style/useDevice";
import { completeMenuItem } from "../MenuItems/completeMenuItem";
import { DeepFriedMenuItem } from "../../../generic-components/menu/DeepFriedMenuItem";
import { DepartmentTemplate } from "./DepartmentTemplate";
import {
  StyledProfileBtn,
  StyledProfileDropdown,
  StyledReactControlledMenu,
  StyledSimpleProfileDropdown,
} from "./SharedStyles";
import { useProfileDepartmentItems } from "./useProfileDepartmentItems";
import { recordProfileMenuUrlDebugTap } from "../../../url/attachCurrentUrlToBody";

export const ProfileMenu = withWSErrorContainer(
  observer(() => {
    const { isTabletOrMobile } = useDevice();
    const { confirmedHasProfileInConcern } = useWhoAmI();
    const { btnProps, controlledMenuProps } = useReactMenuProps();
    const { onClick: openMenu, ...restBtnProps } = btnProps;
    const profileActivatorProps = {
      ...restBtnProps,
      onClick: (e: React.MouseEvent<HTMLElement>) => {
        recordProfileMenuUrlDebugTap();
        openMenu?.(e);
      },
    };

    return (
      <>
        {isTabletOrMobile && (
          <StyledProfileBtn
            role="button"
            className="cvp-profile-btn"
            icon="pi pi-user"
            {...profileActivatorProps}
          />
        )}

        {!isTabletOrMobile && confirmedHasProfileInConcern && (
          <StyledProfileDropdown {...profileActivatorProps}>
            <DepartmentTemplate isTopBar />
            <i className="pi pi-user" />
          </StyledProfileDropdown>
        )}

        {!isTabletOrMobile && !confirmedHasProfileInConcern && (
          <StyledSimpleProfileDropdown {...profileActivatorProps}>
            <i className="pi pi-user" />
          </StyledSimpleProfileDropdown>
        )}

        {/* //React menu */}
        <StyledReactControlledMenu {...controlledMenuProps}>
          <ProfileDepReactMenuItems />
        </StyledReactControlledMenu>
      </>
    );
  })
);

interface ProfileDepReactMenuItemsProps {}

const ProfileDepReactMenuItems = withWSErrorContainer(
  observer((props: ProfileDepReactMenuItemsProps) => {
    const profileItems = useProfileDepartmentItems();
    const pItems = profileItems.map((items) => completeMenuItem(items));

    return (
      <>
        {pItems.map((pItem, index) => (
          <DeepFriedMenuItem key={`${index}_${pItem.label}`} pItem={pItem} />
        ))}
      </>
    );
  })
);
